// extracted by mini-css-extract-plugin
export default {"addToCartControl":"v1-z","giftCard":"w1-z","btnContainer":"x1-z","cartButton":"y1-z","disabled":"z1-z"};